import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import {
  fetchApprovedFolders,
  fetchApprovedSubfolders,
  fetchApprovedFiles,
} from "../services/fetchApprovedFileHierarchy";

// FOR FOLDER ID USE "id" only, I mis structured the implementation of folderId in approved_folders

export async function fetchAllFilesRecursively(adminId) {
  "[DEBUG][ADMIN][TITLE] useFileAnalyticFetch.js -> fetchAllFilesRecursively -> INVOKED";
  const allFiles = [];

  async function traverseFolder(folderId) {
    const subfolders = await fetchApprovedSubfolders(adminId, folderId);
    console.log(
      "[DEBUG][ADMIN][TITLE] traverseFolder -> Subfolders: ",
      subfolders
    );
    for (const subfolder of subfolders) {
      const files = await fetchApprovedFiles(adminId, folderId, subfolder.id);
      allFiles.push(...files);
    }
  }

  const folders = await fetchApprovedFolders(adminId);
  for (const folder of folders) {
    console.log(
      "[DEBUG][ADMIN][TITLE] useFileAnalyticFetch.js -> traverseFolder"
    );
    console.log("[DEBUG][ADMIN][TITLE] traverseFolder -> Folders: ", folders);
    await traverseFolder(folder.id);
  }
  return allFiles;
}

export default function useFileAnalyticFetch(adminId) {
  return useQuery({
    queryKey: ["fileAnalyticsApprovedFiles", adminId],
    queryFn: () => fetchAllFilesRecursively(adminId),
    enabled: !!adminId, // Only fetch if adminId exists
    staleTime: 5 * 60 * 1000, // optional: cache for 5 minutes
  });
}
